(() => {
  if (window.__ewFacetGroups) return;
  const colourParam = 'filter.v.t.shopify.color-pattern';
  const materialParam = 'filter.v.option.material';
  const deliveryParam = 'filter.p.m.custom.tiempo_de_envio';
  const typeParam = 'filter.p.m.custom.tipo_de_producto';
  const locale = (document.documentElement.lang || 'es').split('-')[0].toLowerCase();
  const groups = [];
  const add = (param, label, values, preferred, labels, requirePresent = false) => groups.push({ id: String(groups.length), param, label, values, preferred: preferred || values[0], labels, requirePresent });
  const colours = [
    ['Amarillo','128481132859','254358192443'],
    ['Naranja','128136216891','254358028603'],
    ['Rojo','128513179963','254358094139'],
    ['Rosa','128481100091','254358061371'],
    ['Azul','128482378043','254357831995'],
    ['Verde','128483000635','254357995835'],
    ['Marrón','128482017595','254357897531'],
    ['Bronce','129279787323','254357864763'],
    ['Dorado','129279033659','254357930299'],
    ['Plateado','128054886715','254358126907'],
    ['Gris','128141754683','254357963067'],
    ['Blanco','126960894267','254358159675'],
    ['Negro','127619268923','254357799227']
  ];
  colours.forEach(([label, first, second]) => add(colourParam, label, [first, second].map(id => 'gid://shopify/Metaobject/' + id)));
  const definitionsByLocale = {
    "es": [
      {
        "param": "filter.v.option.material",
        "label": "Cristal templado",
        "values": [
          "Cristal templado",
          "Cristal Templado"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera chapada",
        "values": [
          "Madera chapada",
          "Madera Chapada"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de abeto",
        "values": [
          "Madera de abeto",
          "Madera De Abeto"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caoba",
        "values": [
          "Madera De Caoba",
          "Madera de caoba"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caucho",
        "values": [
          "Madera de caucho",
          "Madera De Caucho"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de fresno",
        "values": [
          "Madera de fresno",
          "Madera De Fresno"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mango",
        "values": [
          "Madera de mango",
          "Madera De Mango"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mindi",
        "values": [
          "Madera de mindi",
          "Madera De Mindi"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de nogal",
        "values": [
          "Madera De Nogal",
          "Madera de nogal"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de olmo",
        "values": [
          "Madera de olmo",
          "Madera De Olmo"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de roble",
        "values": [
          "Madera de roble",
          "Madera De Roble"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Mármol porcelánico",
        "values": [
          "Mármol porcelánico",
          "Mármol Porcelánico"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Papel maché",
        "values": [
          "Papel Maché",
          "Papel maché"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Lana",
        "values": [
          "L",
          "Lana"
        ]
      },
      {
        "param": "filter.v.option.material",
        "label": "Tela",
        "values": [
          "T",
          "Tela"
        ]
      }
    ],
    "en": [
      {
        "param": "filter.v.option.material",
        "label": "Cristal templado",
        "values": [
          "Cristal templado",
          "Cristal Templado"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera chapada",
        "values": [
          "Madera chapada",
          "Madera Chapada"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de abeto",
        "values": [
          "Madera de abeto",
          "Madera De Abeto"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caoba",
        "values": [
          "Madera De Caoba",
          "Madera de caoba"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caucho",
        "values": [
          "Madera de caucho",
          "Madera De Caucho"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de fresno",
        "values": [
          "Madera de fresno",
          "Madera De Fresno"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mango",
        "values": [
          "Madera de mango",
          "Madera De Mango"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mindi",
        "values": [
          "Madera de mindi",
          "Madera De Mindi"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de nogal",
        "values": [
          "Madera De Nogal",
          "Madera de nogal"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de olmo",
        "values": [
          "Madera de olmo",
          "Madera De Olmo"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de roble",
        "values": [
          "Madera de roble",
          "Madera De Roble"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Mármol porcelánico",
        "values": [
          "Mármol porcelánico",
          "Mármol Porcelánico"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Papel maché",
        "values": [
          "Papel Maché",
          "Papel maché"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Wool",
        "values": [
          "L",
          "Wool"
        ]
      },
      {
        "param": "filter.v.option.material",
        "label": "Fabric",
        "values": [
          "T",
          "Fabric"
        ]
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "1-2 weeks",
        "values": [
          "1-2 semanas",
          "1-2 weeks"
        ],
        "preferred": "1-2 weeks"
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "2-4 weeks",
        "values": [
          "2-4 semanas",
          "2-4 weeks"
        ],
        "preferred": "2-4 weeks"
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "1-2 months",
        "values": [
          "1-2 meses",
          "1-2 months"
        ],
        "preferred": "1-2 months"
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "More than 2 months",
        "values": [
          "Más de 2 meses",
          "More than 2 months"
        ],
        "preferred": "More than 2 months"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "Chair",
        "values": [
          "Silla",
          "Chair"
        ],
        "preferred": "Chair"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "Stool",
        "values": [
          "Taburete",
          "Stool"
        ],
        "preferred": "Stool"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "Footstools and poufs",
        "values": [
          "Reposapiés y puffs",
          "Footstools and poufs"
        ],
        "preferred": "Footstools and poufs"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "High stools",
        "values": [
          "Taburetes altos",
          "High stools"
        ],
        "preferred": "High stools"
      }
    ],
    "fr": [
      {
        "param": "filter.v.option.material",
        "label": "Cristal templado",
        "values": [
          "Cristal templado",
          "Cristal Templado"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera chapada",
        "values": [
          "Madera chapada",
          "Madera Chapada"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de abeto",
        "values": [
          "Madera de abeto",
          "Madera De Abeto"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caoba",
        "values": [
          "Madera De Caoba",
          "Madera de caoba"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caucho",
        "values": [
          "Madera de caucho",
          "Madera De Caucho"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de fresno",
        "values": [
          "Madera de fresno",
          "Madera De Fresno"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mango",
        "values": [
          "Madera de mango",
          "Madera De Mango"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mindi",
        "values": [
          "Madera de mindi",
          "Madera De Mindi"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de nogal",
        "values": [
          "Madera De Nogal",
          "Madera de nogal"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de olmo",
        "values": [
          "Madera de olmo",
          "Madera De Olmo"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de roble",
        "values": [
          "Madera de roble",
          "Madera De Roble"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Mármol porcelánico",
        "values": [
          "Mármol porcelánico",
          "Mármol Porcelánico"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Papel maché",
        "values": [
          "Papel Maché",
          "Papel maché"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Laine",
        "values": [
          "L",
          "Laine"
        ]
      },
      {
        "param": "filter.v.option.material",
        "label": "Tissu",
        "values": [
          "T",
          "Tissu"
        ]
      }
    ],
    "nl": [
      {
        "param": "filter.v.option.material",
        "label": "Cristal templado",
        "values": [
          "Cristal templado",
          "Cristal Templado"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera chapada",
        "values": [
          "Madera chapada",
          "Madera Chapada"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de abeto",
        "values": [
          "Madera de abeto",
          "Madera De Abeto"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caoba",
        "values": [
          "Madera De Caoba",
          "Madera de caoba"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caucho",
        "values": [
          "Madera de caucho",
          "Madera De Caucho"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de fresno",
        "values": [
          "Madera de fresno",
          "Madera De Fresno"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mango",
        "values": [
          "Madera de mango",
          "Madera De Mango"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mindi",
        "values": [
          "Madera de mindi",
          "Madera De Mindi"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de nogal",
        "values": [
          "Madera De Nogal",
          "Madera de nogal"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de olmo",
        "values": [
          "Madera de olmo",
          "Madera De Olmo"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de roble",
        "values": [
          "Madera de roble",
          "Madera De Roble"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Mármol porcelánico",
        "values": [
          "Mármol porcelánico",
          "Mármol Porcelánico"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Papel maché",
        "values": [
          "Papel Maché",
          "Papel maché"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Wol",
        "values": [
          "L",
          "Wol"
        ]
      },
      {
        "param": "filter.v.option.material",
        "label": "Stof",
        "values": [
          "T",
          "Stof"
        ]
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "1-2 weken",
        "values": [
          "1-2 semanas",
          "1-2 weken"
        ],
        "preferred": "1-2 weken"
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "2-4 weken",
        "values": [
          "2-4 semanas",
          "2-4 weken"
        ],
        "preferred": "2-4 weken"
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "1-2 maanden",
        "values": [
          "1-2 meses",
          "1-2 maanden"
        ],
        "preferred": "1-2 maanden"
      },
      {
        "param": "filter.p.m.custom.tiempo_de_envio",
        "label": "Meer dan 2 maanden",
        "values": [
          "Más de 2 meses",
          "Meer dan 2 maanden"
        ],
        "preferred": "Meer dan 2 maanden"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "Stoel",
        "values": [
          "Silla",
          "Stoel"
        ],
        "preferred": "Stoel"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "Kruk",
        "values": [
          "Taburete",
          "Kruk"
        ],
        "preferred": "Kruk"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "Voetenbankjes en poefs",
        "values": [
          "Reposapiés y puffs",
          "Voetenbankjes en poefs"
        ],
        "preferred": "Voetenbankjes en poefs"
      },
      {
        "param": "filter.p.m.custom.tipo_de_producto",
        "label": "Hoge krukken",
        "values": [
          "Taburetes altos",
          "Hoge krukken"
        ],
        "preferred": "Hoge krukken"
      }
    ],
    "pt": [
      {
        "param": "filter.v.option.material",
        "label": "Cristal templado",
        "values": [
          "Cristal templado",
          "Cristal Templado"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera chapada",
        "values": [
          "Madera chapada",
          "Madera Chapada"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de abeto",
        "values": [
          "Madera de abeto",
          "Madera De Abeto"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caoba",
        "values": [
          "Madera De Caoba",
          "Madera de caoba"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de caucho",
        "values": [
          "Madera de caucho",
          "Madera De Caucho"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de fresno",
        "values": [
          "Madera de fresno",
          "Madera De Fresno"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mango",
        "values": [
          "Madera de mango",
          "Madera De Mango"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de mindi",
        "values": [
          "Madera de mindi",
          "Madera De Mindi"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de nogal",
        "values": [
          "Madera De Nogal",
          "Madera de nogal"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de olmo",
        "values": [
          "Madera de olmo",
          "Madera De Olmo"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Madera de roble",
        "values": [
          "Madera de roble",
          "Madera De Roble"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Mármol porcelánico",
        "values": [
          "Mármol porcelánico",
          "Mármol Porcelánico"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Papel maché",
        "values": [
          "Papel Maché",
          "Papel maché"
        ],
        "requirePresent": true
      },
      {
        "param": "filter.v.option.material",
        "label": "Lã",
        "values": [
          "L",
          "Lã"
        ]
      },
      {
        "param": "filter.v.option.material",
        "label": "Tecido",
        "values": [
          "T",
          "Tecido"
        ]
      }
    ]
  };
  (definitionsByLocale[locale] || []).forEach(definition => {
    add(definition.param, definition.label, [...new Set(definition.values)], definition.preferred || definition.values[0], { [locale]:definition.label }, definition.requirePresent);
  });
  const byValue = new Map();
  groups.forEach(group => group.values.forEach(value => byValue.set(group.param + '\u0000' + value, group)));
  let serial = 0;
  let observer;
  let queued = false;
  const rawInputs = () => [...document.querySelectorAll('facet-filters-form input[type="checkbox"][name^="filter."]')];
  const groupFor = input => byValue.get(input.name + '\u0000' + input.value);
  const available = input => input.dataset.ewFacetAvailable === 'true';
  const activeValues = param => new Set(new URL(window.location.href).searchParams.getAll(param).flatMap(value => value.split(',')));
  const nativeLabel = input => !input ? '' : input.dataset.ewFacetNativeLabel || input.closest('.facets__item')?.querySelector('.facet-checkbox__text')?.textContent.trim() || '';
  const labelFor = (group, inputs) => {
    if (group.labels) return group.labels[locale] || group.label;
    if (locale === 'es') return group.label;
    const preferred = inputs.find(input => input.value === group.preferred && nativeLabel(input));
    return nativeLabel(preferred || inputs.find(input => nativeLabel(input))) || group.label;
  };
  const updateMaster = (master, group, inputs) => {
    const selected = new Set(inputs.filter(input => input.checked).map(input => input.value));
    master.checked = selected.size > 0;
    master.indeterminate = selected.size > 0 && selected.size < group.values.length;
    master.disabled = !inputs.some(input => available(input) || input.checked);
    const item = master.closest('.facets__item');
    item.classList.toggle('facets__item--checked', master.checked);
    item.classList.toggle('facets__item--disabled', master.disabled);
    item.querySelector('label')?.classList.toggle('facet-checkbox--disabled', master.disabled);
  };
  const refreshList = list => {
    const inputs = [...list.querySelectorAll('input[type="checkbox"][name^="filter."]')];
    groups.forEach(group => {
      const members = inputs.filter(input => input.name === group.param && group.values.includes(input.value));
      if (!members.length) return;
      const active = activeValues(group.param);
      const nativeValues = new Set(members.filter(input => !input.hasAttribute('data-ew-facet-generated')).map(input => input.value));
      if (group.requirePresent && !group.values.every(value => nativeValues.has(value)) && !group.values.every(value => active.has(value))) return;
      members.forEach(input => {
        if (!input.hasAttribute('data-ew-facet-available')) {
          input.dataset.ewFacetAvailable = String(!input.disabled);
          input.dataset.ewFacetNativeLabel = nativeLabel(input);
        }
      });
      let master = list.querySelector('input[data-ew-facet-group="' + group.id + '"]');
      if (!master) {
        const sourceItem = members.find(input => input.closest('.facets__item'))?.closest('.facets__item');
        if (!sourceItem) return;
        const label = labelFor(group, members);
        const item = sourceItem.cloneNode(true);
        item.hidden = false;
        item.removeAttribute('data-ew-facet-member');
        item.removeAttribute('style');
        item.dataset.facetLabel = label.toLowerCase();
        item.dataset.ewFacetGroupItem = group.id;
        master = item.querySelector('input');
        master.removeAttribute('name');
        master.removeAttribute('value');
        master.removeAttribute('data-ew-facet-available');
        master.removeAttribute('data-ew-facet-native-label');
        master.id = 'ew-facet-group-' + group.id + '-' + (++serial);
        master.dataset.ewFacetGroup = group.id;
        master.classList.add('ew-facet-group__input');
        item.querySelector('label').htmlFor = master.id;
        const text = item.querySelector('.facet-checkbox__text');
        if (text) text.textContent = label;
        item.querySelectorAll('.facet-checkbox__count').forEach(count => count.remove());
        sourceItem.before(item);
        group.values.forEach(value => {
          if (members.some(input => input.value === value)) return;
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = group.param;
          input.value = value;
          input.checked = active.has(value);
          input.hidden = true;
          input.dataset.ewFacetAvailable = 'false';
          input.dataset.ewFacetGenerated = group.id;
          item.append(input);
          members.push(input);
        });
      }
      members.forEach(input => {
        input.disabled = false;
        const item = input.closest('.facets__item');
        if (item && !item.hasAttribute('data-ew-facet-group-item')) {
          item.hidden = true;
          item.dataset.ewFacetMember = group.id;
        }
      });
      updateMaster(master, group, members);
    });
    const filter = list.closest('.js-filter');
    const details = filter?.closest('details');
    const summary = details?.querySelector(':scope > summary');
    if (!summary) return;
    const units = new Set([...list.querySelectorAll('input[type="checkbox"][name^="filter."]:checked')].map(input => {
      const group = groupFor(input);
      return group ? 'group-' + group.id : input.name + '\u0000' + input.value;
    }));
    let badge = summary.querySelector('.facets__pill-badge');
    if (!units.size) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'facets__pill-badge';
      const label = summary.querySelector('.facets__accordion-label');
      if (label) label.append(badge);
      else summary.querySelector('.facets__pill-icon')?.before(badge);
    }
    if (badge.textContent !== String(units.size)) badge.textContent = String(units.size);
  };
  const removeMembersURL = group => {
    const url = new URL(window.location.href);
    const entries = url.searchParams.getAll(group.param);
    url.searchParams.delete(group.param);
    entries.forEach(entry => {
      if (group.values.includes(entry)) return;
      const parts = entry.split(',');
      if (!parts.some(part => group.values.includes(part))) {
        url.searchParams.append(group.param, entry);
        return;
      }
      const remaining = parts.filter(part => !group.values.includes(part));
      if (remaining.length) url.searchParams.append(group.param, remaining.join(','));
    });
    url.searchParams.delete('page');
    return url.pathname + url.search + url.hash;
  };
  const chipContainer = anchor => anchor.closest('.active-facets__button') || anchor.closest('facet-remove') || anchor;
  const refreshChips = () => {
    document.querySelectorAll('.active-facets').forEach(scope => {
      const chips = [...scope.querySelectorAll('a[data-param][data-value]')];
      groups.forEach(group => {
        const members = chips.filter(anchor => anchor.dataset.param === group.param && group.values.includes(anchor.dataset.value));
        if (!members.length) return;
        const first = members[0];
        const container = chipContainer(first);
        container.hidden = false;
        container.removeAttribute('data-ew-facet-chip-member');
        first.href = removeMembersURL(group);
        first.dataset.ewFacetGroupRemove = group.id;
        const inputs = rawInputs().filter(input => input.name === group.param && group.values.includes(input.value));
        const label = labelFor(group, inputs) || first.dataset.label || group.label;
        const text = first.querySelector(':scope > span:not(.svg-wrapper):not(.facet-swatch)') || container.querySelector('.active-facets__button-text > span:not(.facet-swatch):not(.svg-wrapper)');
        if (text && text.textContent !== label) text.textContent = label;
        members.slice(1).forEach(anchor => {
          const duplicate = chipContainer(anchor);
          duplicate.hidden = true;
          duplicate.dataset.ewFacetChipMember = group.id;
        });
      });
    });
  };
  const observe = () => observer.observe(document.body, { childList:true, subtree:true });
  const refresh = () => {
    queued = false;
    if (observer) observer.disconnect();
    document.querySelectorAll('facet-filters-form .facets__list').forEach(refreshList);
    refreshChips();
    if (observer) observe();
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(refresh);
  };
  document.addEventListener('input', event => {
    const master = event.target.closest?.('input[data-ew-facet-group]');
    if (!master) return;
    const group = groups[Number(master.dataset.ewFacetGroup)];
    if (!group) return;
    rawInputs().forEach(input => {
      if (input.name === group.param && group.values.includes(input.value)) {
        input.disabled = false;
        input.checked = master.checked;
      }
    });
    document.querySelectorAll('input[data-ew-facet-group="' + group.id + '"]').forEach(input => {
      input.checked = master.checked;
      input.indeterminate = false;
      input.closest('.facets__item').classList.toggle('facets__item--checked', master.checked);
    });
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches?.('facet-filters-form input[type="checkbox"][name^="filter."]')) schedule();
  }, true);
  const clearGroupFromChip = event => {
    if (event.type === 'keyup' && event.code !== 'Space') return;
    const anchor = event.target.closest?.('a[data-ew-facet-group-remove]');
    if (!anchor) return;
    const group = groups[Number(anchor.dataset.ewFacetGroupRemove)];
    if (!group) return;
    rawInputs().forEach(input => {
      if (input.name === group.param && group.values.includes(input.value)) input.checked = false;
    });
    document.querySelectorAll('input[data-ew-facet-group="' + group.id + '"]').forEach(master => {
      master.checked = false;
      master.indeterminate = false;
      master.closest('.facets__item').classList.remove('facets__item--checked');
    });
  };
  document.addEventListener('click', clearGroupFromChip, true);
  document.addEventListener('keyup', clearGroupFromChip, true);
  window.addEventListener('popstate', schedule);
  window.__ewFacetGroups = { refresh };
  const start = () => {
    refresh();
    observer = new MutationObserver(schedule);
    observe();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();